import { useMutation } from "@apollo/client";

import { CURRENT_USER_QUERY, LOGIN_MUTATION } from "../../api";

import {
  FORGOT_PASSWORD_MUTATION,
  RESET_PASSWORD_MUTATION,
  VERIFY_PASSWORD_RESET_TOKEN_MUTATION,
} from "~/api";

export const forgotPassword = () => {
  const [forgotPassword, { error = {}, loading }] = useMutation(
    FORGOT_PASSWORD_MUTATION,
  );

  return {
    mutation: (values) =>
      new Promise((resolve, reject) => {
        const { email, username, ...rest } = values;
        return forgotPassword({
          variables: {
            ...rest,
            ...(email ? { email: email?.toLowerCase() } : {}),
            ...(username ? { username: username?.toLowerCase() } : {}),
          },
        })
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      }),
    loading,
    error,
  };
};

export const useVerifyPasswordResetToken = () => {
  const [verify, { loading }] = useMutation(
    VERIFY_PASSWORD_RESET_TOKEN_MUTATION,
  );

  return {
    verify: ({ uid, token }) =>
      verify({ variables: { uid, token } }).then(
        ({ data }) => data?.verifyPasswordResetToken,
      ),
    loading,
  };
};

export const useResetPassword = () => {
  const [resetPasswordMutation, { error = {}, loading }] = useMutation(
    RESET_PASSWORD_MUTATION,
  );

  return {
    mutation: ({ uid, token, password }) =>
      resetPasswordMutation({ variables: { uid, token, password } }),
    loading,
    error,
  };
};

export const useUserLogin = () => {
  const [login, { error, loading }] = useMutation(LOGIN_MUTATION);

  return {
    error,
    loading,
    submitLogin: async (variables) =>
      login({
        variables,
        refetchQueries: [
          {
            query: CURRENT_USER_QUERY,
          },
        ],
      }),
  };
};
